import { useFormState } from 'informed';
import React, { FC, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

import { InputStructure } from '../structures/InputStructure';
import { getErrorTranslation } from '../utils';
import { ValidatorMessage } from '@/helpers/validators';

import { ScFormGroup, ScFormGroupProps } from './styled';

interface FormGroupProps extends ScFormGroupProps {
  title?: string;
  error?: React.ReactNode;
  addons?: React.ReactElement;
  tooltip?: React.ReactElement;
  field?: string;
  showErrorMessage?: boolean;
}

export const FormGroup: FC<PropsWithChildren<FormGroupProps>> = ({
  children,
  title,
  error,
  tooltip,
  addons,
  marginTop,
  field,
  showErrorMessage,
  ...rest
}) => {
  const { t } = useTranslation();

  const { errors } = useFormState();

  return (
    <ScFormGroup marginTop={marginTop} {...rest}>
      <>
        {title && <h3>{title}</h3>}
        {tooltip && <div className="tooltip">{tooltip}</div>}
        <InputStructure error={error}>{children}</InputStructure>
        {addons && <div className="addons">{addons}</div>}
        {showErrorMessage && field && errors[field] && (
          <div className="error">
            {getErrorTranslation(t, errors[field] as ValidatorMessage)}
          </div>
        )}
      </>
    </ScFormGroup>
  );
};
